import { RouteNames } from '../constants/routes';
import { Step } from '../types';

export function convertUrlToBreadcrumbStep(url: string): Step | undefined {
  if (
    url.includes(RouteNames.TICKET_SELECTOR) ||
    url.includes(RouteNames.TICKET_TYPES)
  ) {
    return 'tickets';
  }
  if (
    url.includes(RouteNames.SEARCH_RESULT_TICKETS) ||
    url.includes(RouteNames.FLEXIBLE_TICKETS) ||
    url.includes(RouteNames.PAYG_TICKETS)
  ) {
    return 'results';
  }
  if (
    url.includes(RouteNames.BOOKING_SUMMARY) ||
    url.includes(RouteNames.DIRECT_DEBIT) ||
    url.includes(RouteNames.PAYMENT_FAILED)
  ) {
    return 'details';
  }
  if (url.includes(RouteNames.BOOKING_CONFIRMATION)) {
    return 'confirmation';
  }
  return undefined;
}
